module.exports = __webpack_public_path__ + "img/favor_normal.f0c299d9.png";